import { useQuery } from '@tanstack/react-query'
import { getAuth } from 'firebase/auth'
import { useEffect } from 'react'
import http from '../../utils/Http/Http'

const getLeads = async (userId, campaignId, limit, searchParams) => {
	const leadsUrl = '/leads'
	const { lead_status } = Object.fromEntries(searchParams)
	const params = {
		limit,
		lead_status,
		user_id: encodeURIComponent(userId),
		campaign_id: encodeURIComponent(campaignId),
	}

	try {
		const res = await http({
			params,
			url: leadsUrl,
			method: 'get',
		})
		if (res.status === 200) {
			return { leads: res.data.leads, loadMore: !!res.data?.pagination?.next_page }
		} else {
			return { leads: [], loadMore: false }
		}
	} catch (e) {
		return { leads: [], loadMore: false }
	}
}

const getLeadConversions = async (params) => {
	const response = await http({
		url: '/leads',
		method: 'get',
		params: {
			get_conversions: true,
			team_id: params.teamId,
			start_dt: params.startDate,
			end_dt: params.endDate,
		},
	})

	return response.data
}

export default function useFetchLeads(campaignId, limit, params = new URLSearchParams()) {
	const auth = getAuth()
	const user = auth.currentUser
	const {
		status,
		error,
		data: { leads, loadMore } = {},
		isFetching: fetchingLeads,
		refetch: refetchLeads,
	} = useQuery({
		queryFn: () => getLeads(user.uid, campaignId, limit || process.env.REACT_APP_DEFAULT_PAGING, params),
		queryKey: [`leads_${campaignId}`],
		enabled: !!campaignId,
	})

	useEffect(() => {
		refetchLeads()
	}, [params])

	return {
		leads,
		fetchingLeads,
		error,
		loadMore,
		pendingLeads: status === 'pending',
	}
}

export function useFetchLeadConversions(teamId, startDate, endDate) {
	const { data, isFetching, error } = useQuery({
		queryFn: () => getLeadConversions({ teamId, startDate, endDate }),
		queryKey: ['lead_conversions', teamId, startDate, endDate],
		enabled: !!teamId,
	})

	return { loading: isFetching, conversions: data, error }
}
